import { Col, Row } from "antd";
import React, { useEffect } from "react";

import "../../../../../assets/styles/custom/customStyles/cutomStyles.css";
import BreadcrumbComponent from "../../../CommonComponent/BreadcrumbComponent";
import { ExplorationBreadcrumb } from "../../../../../config/BreadcrumbConfig";

const resourceSections = [
  {
    title: "Veterans and Solar",
    color: "#0D5E0D",
    resources: [
      {
        title: "Solar Ready Vets",
        desc: "A program that connects transitioning military service members and veterans with career opportunities in the solar industry.",
        link: "https://irecusa.org/programs/solar-ready-vets/",
      },
      {
        title: "Solar Ready Vets",
        desc: "Center for Energy Workforce Development's interactive roadmap to energy jobs and related training programs. Includes jobs, skills, and certifications.",
        link: "http://troopstoenergyjobs.com/roadmap/translate.php",
      },
      {
        title: "Solar Ready Vets",
        desc: "Civilian occupational crosswalk and career exploration tool from O*Net career exploration tool.",
        link: "https://www.mynextmove.org/vets/",
      },
    ],
  },
  {
    title: "Solar Training",
    color: "#0D5E0D",
    resources: [
      {
        title: "IREC's Online Clean Energy Training",
        desc: "Online solar training for firefighters, authorities having jurisdiction (AHJs), code officials, installers, and a variety of other occupations. For the next steps on your career pathway, check out our new Solar Career Course on our training website. Additionally, IREC's Training Provider Map can be found here.",
        link: "https://cleanenergytraining.org/",
      },
      {
        title: "IREC Training Provider Map",
        desc: "Our online training provider map shows training based on criteria such as online training, NABCEP registration, and more.",
        link: "/locations",
      },
      {
        title: "My Skills My Future",
        desc: "U.S. Department of Labor tool to match general skills and interests with industry-specific credentials and geographically specific educational opportunities.",
        link: "http://www.myskillsmyfuture.org/",
      },
    ],
  },
  {
    title: "Licensing and Certifications",
    color: "#0D5E0D",
    resources: [
      {
        title: "NABCEP",
        desc: "NABCEP, the North American Board of Certified Energy Practitioners, offers certifications and credentials for skilled professionals, specialists, and those new to working in the areas of photovoltaics, solar heating, and small wind technologies.",
        link: "https://cleanenergytraining.org/",
      },
      {
        title: "Solar Licensing Database",
        desc: "REC's National Solar Licensing Database provides the latest licensing, certification, and other requirements impacting the solar industry. This comprehensive tool is designed for policymakers, stakeholders, practitioners, students, consumers, and anyone looking for solar licensing information in the United States.",
        link: "https://cleanenergytraining.org/",
      },
    ],
  },
  {
    title: "Jobs & Industry Overview",
    color: "#0D5E0D",
    resources: [
      {
        title: "National Solar Jobs Census",
        desc: "IREC’s annual report tracking jobs and workforce development in the solar and storage industry.",
        link: "https://irecusa.org/programs/solar-jobs-census/",
      },
      {
        title: `National Clean Energy Workforce Alliance`,
        desc: `A cross-sector forum led by IREC to improve clean energy education, training, and job placement outcomes.`,
        link: "https://cleanenergytraining.org/",
      },
      {
        title: "Solar Energy Industry Association",
        desc: "SEIA is the national trade association for the U.S. solar industry.",
        link: "https://www.seia.org/",
      },
    ],
  },
];

/**
 * Renders component for All Careers .
 *
 * @return {JSX.Element} The rendered component.
 */
const Index = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div style={{ background: "#f5f6f7" }} className="all-careers-mobile">
      <section>
        <div className="container-fluid">
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <div className="career-index-header mobile-header">
                <BreadcrumbComponent
                  key={1}
                  items={ExplorationBreadcrumb.path}
                />
                <div
                  style={{
                    fontSize: 17,
                    color: "#555",
                    marginLeft: 5,
                    marginTop: 10,
                  }}
                >
                  A few starting points for further exploration of skills,
                  training, and jobs in solar.
                </div>
              </div>
            </Col>

            <Col span={24}>
              {resourceSections.map((section) => (
                <div
                  className="resource-section"
                  key={section.title}
                  style={{
                    background: "#ffffff",
                    borderRadius: 16,
                    marginBottom: 32,
                    padding: "32px 24px",
                    boxShadow: "none",
                    border: "none",
                  }}
                >
                  <div
                    className="resource-section-title"
                    style={{
                      color: section.color,
                      fontSize: 22,
                      fontWeight: 500,
                      marginBottom: 24,
                      fontFamily: "Outfit, sans-serif",
                    }}
                  >
                    {section.title}
                  </div>
                  <Row gutter={24} align="stretch">
                    {section.resources.map((resource) => (
                      <Col
                        xs={24}
                        md={8}
                        key={resource.title + resource.link}
                        style={{ display: "flex" }}
                      >
                        <a
                          href={resource.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: "flex",
                            flex: 1,
                            textDecoration: "none",
                            height: "100%",
                          }}
                        >
                          <div
                            className="resource-card"
                            style={{
                              background: "#fff",
                              border: "1px solid #e5e7eb",
                              borderRadius: 12,
                              padding: "24px 20px",
                              marginBottom: 16,
                              minHeight: 180,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              flex: 1,
                              transition: "box-shadow 0.2s, border-color 0.2s",
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.boxShadow =
                                "0 2px 8px rgba(0,0,0,0.06)";
                              e.currentTarget.style.borderColor = section.color;
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.boxShadow = "none";
                              e.currentTarget.style.borderColor = "#e5e7eb";
                            }}
                          >
                            <div
                              className="resource-card-title"
                              style={{
                                fontSize: 20,
                                fontWeight: 500,
                                marginBottom: 10,
                                color: "#222424",
                                fontFamily: "Outfit, sans-serif",
                              }}
                            >
                              {resource.title}
                            </div>
                            <div
                              className="resource-card-desc"
                              style={{
                                fontSize: 15,
                                color: "#535555",
                                marginBottom: 0,
                                fontFamily: "Outfit, sans-serif",
                                fontWeight: 300,
                              }}
                            >
                              {resource.desc}
                            </div>
                          </div>
                        </a>
                      </Col>
                    ))}
                  </Row>
                </div>
              ))}
            </Col>
          </Row>
        </div>
      </section>
    </div>
  );
};

export default Index;
